module.exports = __webpack_public_path__ + "img/map_mezzanine-2.7546595d.jpg";